import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class StandardFernwaermemix extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    jahr: number | null = null;
    kanton_id: number | null = null;
    gemeinde_id: number | null = null;
    energie_waermequelle_id: number | null = null;
    anteil: number | null = null;
    bemerkung: string | null = null;

    // view fields
    kanton_kuerzel: string | null = null;
    kanton: string | null = null;
    gemeinde: string | null = null;
    energie_waermequelle_i18n_key: string | null = null;
    energie_waermequelle_code: number | null = null;
    energie_waermequelle_bezeichnung: string | null = null;


    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'StandardFernwaermemix';
    }
}

export async function createNewStandardFernwaermemix(): Promise<StandardFernwaermemix> {
    const model = createModel(StandardFernwaermemix, {});

    await model.save();
    return model;
}

export class StandardFernwaermemixCollection extends BaseCollection<StandardFernwaermemix> {
    protected modelCls = StandardFernwaermemix;

    public getModelClassName(): string {
        return 'StandardFernwaermemix';
    }
}
